import './application.css'
import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'

createInertiaApp({
  title: (title) => (title ? `${title} — Lixi Atlas` : 'Lixi Atlas'),
  resolve: (name) => {
    const pages = import.meta.glob(['../pages/**/*.tsx', '../wireframes/**/*.tsx'], { eager: true })
    return pages[`../pages/${name}.tsx`] || pages[`../${name}.tsx`]
  },
  setup({ el, App, props }) {
    createRoot(el).render(<App {...props} />)
  },
})
